<!-- Trigger to Open the Modal -->
<button type="button" class="btn bg-transparent px-4 py-0" data-bs-toggle="modal" data-bs-target="#categoryTagManagerModal">
  <i class="bi bi-folder-fill fs-2"></i>
</button>


<teleport to="body">
<!-- Modal -->
<div class="modal fade" id="categoryTagManagerModal" tabindex="-1" aria-labelledby="category_tag_manager_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content rounded-5">

      <div class="modal-header bg-primary position-relative">
        <h6 id="category_tag_manager_label" class="modal-title text-white text-xs">Category & Tag Manager</h6>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <!-- Add New Category Section -->
        <div class="mb-4">
          <div class="d-flex gap-1 align-items-center mb-2">
            <input
              type="text"
              v-model="category_name"
              @keypress.enter="handleKeyPress('category')"
              class="form-control form-control-sm py-2 px-2 text-xxs rounded-pill"
              placeholder="Enter category name..."
            />
            <button
              class="btn btn-primary btn-sm py-1 px-2 text-xxs rounded-3"
              :disabled="!category_name.trim()"
              @click="() => handleKeyPress('category')"
            >
              Save
            </button>
          </div>
        </div>


        <!-- Categories List -->
        <div v-if="categories.length === 0" class="text-center text-muted py-5">
          <i class="bi bi-folder-fill display-4 opacity-25 mb-2"></i>
          <p class="lead">No categories yet. Create your first category above!</p>
        </div>

        <div v-else class="vstack gap-5">
          <div
            v-for="category in categories"
            :key="category.id"
            class="card border shadow-sm mb-2 rounded-5"
          >
            <div class="card-header d-flex justify-content-between align-items-center bg-light rounded-5 border-bottom-0">
              <h6 class="mb-0 d-flex align-items-center gap-2 text-dark">
                <i class="bi bi-folder-fill text-primary"></i>
                {{ category.name }}
                <span class="badge text-primary ms-2 text-xxs">
                  {{ category.tags?.length || 0 }} tags
                </span>
              </h6>
              <div class="d-flex gap-2">
  <button
  class="btn btn-sm"
  @click.prevent="openEditCategoryModal(category)"
  aria-label="Edit Category"
>
  <i class="bi bi-pencil-fill"></i>
</button>

  <button
    class="btn btn-sm text-danger"
    @click.prevent="delete_category(category.id)"
  >
    <i class="bi bi-trash"></i>
  </button>
</div>

            </div>

            <div class="card-body">
              <!-- Add Tag Input -->
              <div class="d-flex gap-1 align-items-center mb-2">
                <input
                  type="text"
                  :value="tag_name.get(category.id) || ''"
                  @input="e => handleTagInputChange(category.id, e.target.value)"
                  @keypress.enter="handleKeyPress('tag', category.id)"
                  class="form-control form-control-sm py-2 px-2 text-xxs rounded-pill"
                  placeholder="Enter tag name..."

                />
                <button
                  class="btn btn-primary py-1 px-2 text-xxs rounded-3"
                  :disabled="!(tag_name.get(category.id) || '').trim()"
                  @click="() => addTag(category.id)"
                >
                  Save
                </button>
              </div>


              <!-- Tag List -->
              <div v-if="category.tags && category.tags.length === 0" class="text-center text-muted fst-italic py-3">
                No tags yet. Add your first tag above!
              </div>
              <div v-else class="d-flex flex-wrap gap-2">
<span
  v-for="tag in category.tags"
  :key="tag.id"
  class="badge bg-success-subtle text-success
         d-flex gap-2 align-items-start
         px-3 py-2 text-xxs
         border border-success rounded-pill
         w-100"
  style="
    max-width: 100%;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
  "
>
  <i class="bi bi-tag mt-1"></i>

  <!-- Text -->
  <span class="flex-grow-1">
    {{ tag.name }}
  </span>

  <!-- Actions -->
  <div class="d-flex gap-2">
    <button
      class="btn btn-sm p-0"
      @click="openEditModal(category.id, tag)"
    >
      <i class="bi bi-pencil"></i>
    </button>

    <button
      class="btn btn-sm text-danger p-0"
      @click="delete_tag(tag.id, category.id)"
    >
      <i class="bi bi-trash"></i>
    </button>
  </div>
</span>


</div>
            </div>

          </div>
        </div>

        <!-- Summary -->
        <div class="mt-5 bg-light p-3 rounded">
          <div class="d-flex justify-content-center gap-4 text-secondary small">
            <div><i class="bi bi-folder"></i> {{ categories.length }} Categories</div>
            <div><i class="bi bi-tag"></i> {{ totalTags }} Total Tags</div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          :disabled="categories.length === 0"
          @click="create_tag_category"
        >
          <i class="bi bi-check-circle me-1"></i> Save All
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Single Edit Category Modal -->
<div
  class="modal fade"
  id="editCategoryModal"
  tabindex="-1"
  aria-labelledby="editCategoryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-5 shadow scrollable-container">

      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs" id="editCategoryModalLabel">Edit Category</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
      </div>

      <div class="modal-body">
        <input
          type="text"
          class="form-control shadow-sm rounded-5 text-xs"
          v-model="edit_category"
          placeholder="Category Name"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          @click="update_category()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Single Edit Tag Modal -->
 <div
  class="modal fade"
  id="editTagModal"
  tabindex="-1"
  aria-labelledby="editTagModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded-5">

      <div class="modal-header bg-primary position-relative">
        <h5 class="modal-title text-white text-xs" id="editTagModalLabel">Edit Tag</h5>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
      </div>

      <div class="modal-body">
        <input
          type="text"
          class="form-control shadow-sm rounded-5 text-xs"
          v-model="edit_tag_name"
          placeholder="Tag Name"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-sm btn-primary rounded-3 text-xs shadow-sm"
          @click="update_tag()"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

</teleport>